import {
  ModalType,
  useCampaignContext,
  useFeatureFlagContext,
  useModalContext,
} from 'modules/campaigns/editor/context';
import { useSendTimeExperiment } from 'modules/campaigns/editor/hooks';
import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { TimeClock24 } from 'ui/icons';
import { Tooltip } from 'ui/tooltip';
import { CampaignState } from 'modules/domains/campaign';
import { CampaignPopover } from '../../../CampaignPopover';
import { CampaignPermissionCheck } from '../../CampaignPermissionCheck';

export const RescheduleCampaignAction = () => {
  const {
    campaign: { campaignState },
  } = useCampaignContext();
  const { isSuspendSendsEnabled } = useFeatureFlagContext();
  const { openModal } = useModalContext();
  const { hasSendTimeExperiment } = useSendTimeExperiment();

  return (
    <CampaignPermissionCheck action={'reschedule'} ChildWrapper={CampaignPopover}>
      <Tooltip
        isEnabled={hasSendTimeExperiment}
        tooltipContent="This campaign has send time experiments. It cannot be rescheduled."
      >
        <SecondaryButton
          data-test="reschedule-button"
          size={BUTTON_SIZES.LARGE}
          onClick={() => openModal(ModalType.ScheduleCampaign)}
          isDisabled={
            hasSendTimeExperiment ||
            (campaignState === CampaignState.Scheduled && isSuspendSendsEnabled)
          }
        >
          <TimeClock24 />
          Reschedule
        </SecondaryButton>
      </Tooltip>
    </CampaignPermissionCheck>
  );
};
